var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Icon } from '@project/components/base';
import { Button } from '../Forms/Fields';
import FilterPopover from './FilterPopover';
import FilterList from './FilterList';
import { CustomPopover } from '../Popover';
import { FilterPopoverContainer, FilterControlsContainer } from './styles';
import { FilterTypes } from './constants';
import { getActiveFilters, buildQueryString } from './helpers';
export var FilterDataset = function (_a) {
    var queryString = _a.queryString, columns = _a.columns, onFilterUpdate = _a.onFilterUpdate, _b = _a.isCondition, isCondition = _b === void 0 ? false : _b, _c = _a.disablePopup, disablePopup = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.isRule, isRule = _e === void 0 ? false : _e;
    var _f = useState(false), showFilterPopover = _f[0], setShowFilterPopover = _f[1];
    var _g = useState(false), showFilterComponent = _g[0], setShowFilterComponent = _g[1];
    var _h = useState(getActiveFilters(queryString)), activeFilters = _h[0], setActiveFilters = _h[1];
    useEffect(function () {
        setActiveFilters(getActiveFilters(queryString));
    }, [queryString]);
    var hideFilterPopover = function () {
        if (disablePopup) {
            setShowFilterComponent(false);
        }
        else {
            setShowFilterPopover(false);
        }
    };
    var toggleFilterPopover = function () {
        if (disablePopup) {
            setShowFilterComponent(function (previous) { return !previous; });
        }
        else {
            setShowFilterPopover(function (previous) { return !previous; });
        }
    };
    var updateFilters = function (filters) {
        setActiveFilters(filters);
        onFilterUpdate(buildQueryString(filters));
    };
    var updateFiltersFromPrevious = function (newFilter) {
        setActiveFilters(function (previousFilters) {
            var newFilters = __spreadArray(__spreadArray([], previousFilters, true), [newFilter], false);
            onFilterUpdate(buildQueryString(newFilters));
            return newFilters;
        });
    };
    var applyFilters = function (selectedColumn, selectedFilterType, value) {
        updateFiltersFromPrevious({
            key: selectedColumn,
            operation: selectedFilterType,
            value: value,
        });
        hideFilterPopover();
    };
    var removeFilter = function (filter) {
        var newQueryArray = activeFilters.filter(function (item) { return item !== filter; });
        updateFilters(newQueryArray);
    };
    var removeAllFilters = function () {
        updateFilters([]);
    };
    return (_jsxs(FilterPopoverContainer, { children: [disablePopup ? (_jsxs("div", __assign({ className: "w-full" }, { children: [showFilterComponent && !disabled && (_jsx(FilterPopover, { filterTypes: FilterTypes, applyFilters: applyFilters, hideFilterPopover: hideFilterPopover, columns: columns, disablePopup: true, isRule: isRule })), (!showFilterComponent || disabled) && (_jsxs(FilterControlsContainer, { children: [_jsxs(Button, __assign({ small: true, subdued: true, onClick: toggleFilterPopover, disabled: disabled }, { children: [isCondition ? 'Conditions' : 'Filters', _jsx(Icon, { style: { marginLeft: '10px' }, className: "fa fa-plus" })] })), activeFilters.length > 0 && (_jsxs(Button, __assign({ small: true, subdued: true, onClick: removeAllFilters, style: { marginLeft: '10px' } }, { children: [isCondition ? 'Clear conditions' : 'Clear filters', _jsx(Icon, { style: { marginLeft: '10px' }, className: "fa fa-times" })] })))] }))] }))) : (_jsx(CustomPopover, __assign({ body: _jsx(FilterPopover, { filterTypes: FilterTypes, applyFilters: applyFilters, hideFilterPopover: hideFilterPopover, columns: columns }), isOpen: showFilterPopover, preferPlace: "left", bgColor: "#fff", borderColor: "#ccc", borderRadius: 5, onOuterAction: hideFilterPopover }, { children: _jsxs(FilterControlsContainer, { children: [_jsxs(Button, __assign({ small: true, subdued: true, onClick: toggleFilterPopover }, { children: [isCondition ? 'Conditions' : 'Filters', _jsx(Icon, { style: { marginLeft: '10px' }, className: "fa fa-plus" })] })), activeFilters.length > 0 && (_jsxs(Button, __assign({ small: true, subdued: true, onClick: removeAllFilters, style: { marginLeft: '10px' } }, { children: [isCondition ? 'Clear conditions' : 'Clear filters', _jsx(Icon, { style: { marginLeft: '10px' }, className: "fa fa-times" })] })))] }) }))), _jsx(FilterList, { activeFilters: activeFilters, onRemoveFilter: removeFilter })] }));
};
export default FilterDataset;
